import styled, {keyframes, css} from 'styled-components';
import { device } from '../../../utils/responsive_utilities';
import {white} from '../../loggedout/shared-styles/Colors';
import FontGraphie from '../../loggedout/shared-styles/graphieFont';
const TextAnimation = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
export const SetUpText = styled.p`
  position: absolute;
  width: 95%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${white};
  font: normal 700 2.8rem/3.2rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  opacity: 0;
  animation: ${TextAnimation}  5s ${props=>props.timeOut || '2s'} ease-out none;

  @media ${device.Phone}{
    ${FontGraphie(2,1,7)}
  }
  @media ${device.PhoneTabletLandscape}{
    width: 60%;
    ${FontGraphie(1.8,1.2,7)}
  }
`;
